import config from '../../../config';

export default {
  init(storeDispatch) {
    const companyConfig = config;
    const { company } = config.standaloneAppData;

    if (companyConfig.companies[company.uuid]) {
      companyConfig.appSettings = _.merge(
        companyConfig.appSettings,
        companyConfig.companies[company.uuid].appSettings,
      );
    }

    const tabs = _.filter(_.sortBy(companyConfig.appSettings.ticket.tabs, ['position']), { disabled: false });
    const defaultType = companyConfig.appSettings.ticket.activeType;

    storeDispatch('updateAppSettings', config.standaloneAppData);
    storeDispatch('updateCompanyConfig', companyConfig.appSettings);
    storeDispatch('updateTicketType', parseInt(defaultType, 10));
    storeDispatch('updateBetslipTabs', tabs);
    storeDispatch('initApp');
  },

};
